module.exports = __webpack_public_path__ + "word.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/word.png
// module id = 391
// module chunks = 0